<template>
	<form
		class="needs-validation cm-contactform carmarket-form"
		@submit.prevent="sendMessage()"
		novalidate
	>
		<div class="mb-3 row gx-2">
			<label class="col-md-3 col-form-label">Anliegen</label>
			<div class="col-md-9">
				<div class="form-check">
					<input
						v-model="form.subject"
						class="form-check-input"
						type="checkbox"
						value="inzahlungnahme"
						id="form-check-inzahlungnahme"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="form-check-inzahlungnahme">
						Gebrauchtwagen Inzahlungnahme
					</label>
				</div>
				<!-- <div class="form-check">
					<input
						v-model="form.subject"
						class="form-check-input"
						type="checkbox"
						value="lieferung"
						id="form-check-lieferung"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="form-check-lieferung">
						Haustürlieferung
					</label>
				</div> -->
				<div class="form-check">
					<input
						v-model="form.subject"
						class="form-check-input"
						type="checkbox"
						value="probefahrt"
						id="form-check-probefahrt"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="form-check-probefahrt">
						Probefahrt
					</label>
				</div>
				<div class="form-check">
					<input
						v-model="form.subject"
						class="form-check-input"
						type="checkbox"
						value="versicherung"
						id="form-check-versicherung"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="form-check-versicherung">
						Versicherung
					</label>
				</div>
				<div class="form-check">
					<input
						v-model="form.subject"
						class="form-check-input"
						type="checkbox"
						value="gewerbe"
						id="form-check-gewerbe"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="form-check-gewerbe">
						Gewerbliche Nutzung
					</label>
				</div>
			</div>
		</div>
		<div class="mb-3 row gx-2">
			<label class="col-md-3 col-form-label">Firma (optional)</label>
			<div class="col-md-9">
				<input
					v-model="form.firma"
					type="text"
					class="form-control"
					id="cm-contact-firma"
					placeholder="Firma"
					:disabled="isSend"
				/>
			</div>
		</div>
		<div
			class="mb-3 row gx-2 form-row"
			:class="{
				'is-invalid': v$.form.vorname.$error || v$.form.nachname.$error
			}"
		>
			<label class="col-md-3 col-form-label required">Name</label>
			<div class="col-md-9">
				<div class="row g-2">
					<div class="col-md-6">
						<input
							v-model="form.vorname"
							type="text"
							class="form-control"
							id="cm-contact-name"
							placeholder="Vorname"
							:disabled="isSend"
							required
						/>
						<span class="form-msg form-error-msg">
							Bitte einen Vorname eintragen.
						</span>
					</div>
					<div class="col-md-6">
						<input
							v-model="form.nachname"
							type="text"
							class="form-control"
							id="cm-contact-nachname"
							placeholder="Nachname"
							:disabled="isSend"
							required
						/>

						<span class="form-msg form-error-msg">
							Bitte einen Nachnamen eintragen.
						</span>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mb-3 row gx-2 form-row"
			:class="{ 'is-invalid': v$.form.email.$error }"
		>
			<label class="col-md-3 col-form-label required">E-Mail Adresse</label>
			<div class="col-md-9">
				<input
					v-model="form.email"
					type="email"
					class="form-control"
					id="cm-contact-email"
					:disabled="isSend"
					placeholder="ihre@email.de"
					required
				/>
				<span class="form-msg form-error-msg">
					Bitte eine gültige E-Mail Adresse eintragen.
				</span>
			</div>
		</div>
		<div
			class="mb-3 row gx-2 form-row"
			:class="{ 'is-invalid': v$.form.phone.$error }"
		>
			<label class="col-md-3 col-form-label required">Telefon / Mobil</label>
			<div class="col-md-9">
				<input
					v-model="form.phone"
					type="text"
					class="form-control"
					id="cm-contact-phone"
					placeholder="0123 / 123 123"
					:disabled="isSend"
				/>
				<span class="form-msg form-error-msg">
					Bitte eine Rufnummer Adresse eintragen.
				</span>
			</div>
		</div>
		<div
			class="mb-3 row form-row gx-2"
			:class="{ 'is-invalid': v$.form.contact_type.$error }"
		>
			<label class="col-md-3 col-form-label required"
				>Bevorzugte Kontaktart</label
			>
			<div class="col-md-9 pt-1">
				<div class="d-block">
					<div class="form-check form-check-inline">
						<input
							v-model="form.contact_type"
							class="form-check-input"
							type="radio"
							name="form-radio-contact-email"
							id="form-radio-contact-email"
							value="email"
							:disabled="isSend"
						/>
						<label class="form-check-label" for="form-radio-contact-email"
							>E-Mail</label
						>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.contact_type"
							class="form-check-input"
							type="radio"
							name="form-radio-contact-telefon"
							id="form-radio-contact-telefon"
							value="phone"
							:disabled="isSend"
						/>
						<label class="form-check-label" for="form-radio-contact-telefon"
							>Telefon</label
						>
					</div>
				</div>
				<span class="form-msg form-error-msg">
					Bitte bevorzugte Kontaktart auswählen.
				</span>
			</div>
		</div>
		<div
			class="mb-3 row gx-2 form-row"
			:class="{
				'is-invalid': v$.form.payment.$error || v$.form.payment.$error
			}"
		>
			<label class="col-md-3 col-form-label required">Zahlungsart</label>
			<div class="col-md-9 pt-1">
				<div class="form-check form-check-inline">
					<input
						class="form-check-input"
						type="radio"
						v-model="this.$store.state.price.view"
						name="payment"
						id="payment-finance"
						value="finance"
						autocomplete="off"
						@change="setFormMessage('finance')"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="payment-finance"
						>Finanzierung</label
					>
				</div>

				<div class="form-check form-check-inline">
					<input
						class="form-check-input"
						type="radio"
						v-model="this.$store.state.price.view"
						name="payment"
						id="payment-fixed"
						value="fixed"
						autocomplete="off"
						@change="setFormMessage('fixed')"
						:disabled="isSend"
					/>
					<label class="form-check-label" for="payment-fixed">Barkauf</label>
				</div>
				<div class="form-check form-check-inline">
					<input
						class="form-check-input"
						type="radio"
						v-model="this.$store.state.price.view"
						name="payment"
						id="payment-leasing"
						value="leasing"
						autocomplete="off"
						@change="setFormMessage('leasing')"
						:disabled="!car.leasing || isSend"
					/>
					<label class="form-check-label" for="payment-leasing">Leasing</label>
				</div>
				<p
					v-if="this.$store.state.price.view === 'finance'"
					class="text-muted font-14 mt-2 mb-0"
				>
					Fahrzeug und Finanzierungsoptionen werden automatisch mitgesendet.
					<br />
					Laufzeit:
					{{ getPrice(this.$store.state.price.financing.period) }} Monate,
					Anzahlung:
					{{ getPrice(this.$store.state.price.financing.deposit) }} €,
					Monatsrate:
					{{
						this.car.finance
							? 'Monatsrate: ' +
							  getPrice(this.$store.state.price.financing.rate) +
							  ' €'
							: 'Auf Anfrage'
					}}.<br />
					<a
						href="#"
						@click.prevent="scrollTo('car-detail-pricing', -60)"
						class=""
						>Finanzierung anpassen</a
					>
				</p>
				<p
					v-else-if="this.$store.state.price.view === 'leasing'"
					class="text-muted font-14 mt-2 mb-0"
				>
					Fahrzeug und Leasingoptionen werden automatisch mitgesendet.
					<br />
					Laufzeit:
					{{ getPrice(this.$store.state.price.leasing.period) }} Monate,
					Kilometer: {{ getPrice(this.$store.state.price.leasing.mileage) }} Km
					, Sonderzahlung:
					{{ getPrice(this.$store.state.price.leasing.deposit) }} €, Monatsrate:
					{{ getPrice(this.$store.state.price.leasing.rate) }} €.<br />
					<a
						href="#"
						@click.prevent="scrollTo('car-detail-pricing', -60)"
						class=""
						>Leasing anpassen</a
					>
				</p>
				<p v-else class="text-muted font-14 mt-2 mb-0">
					Fahrzeuginformationen und Kaufpreis werden automatisch mitgesendet.
				</p>
			</div>
		</div>
		<div
			class="mb-3 row gx-2 form-row"
			:class="{ 'is-invalid': v$.form.message.$error }"
		>
			<label class="col-md-3 col-form-label required">Ihre Nachricht</label>
			<div class="col-md-9">
				<textarea
					id="cm-contact-message"
					v-model="form.message"
					class="form-control"
					style="height: 200px"
					cols="50"
					rows="6"
					aria-required="true"
					:disabled="isSend"
					required
				></textarea>
				<span class="form-msg form-error-msg">
					Bitte eine Nachricht verfassen.
				</span>
			</div>
		</div>
		<div
			class="mb-3 row gx-2 form-row"
			:class="{ 'is-invalid': v$.form.datenschutz.$error }"
		>
			<label class="col-md-3 col-form-label required">Datenschutz</label>
			<div class="col-md-9">
				<div class="form-check">
					<input
						v-model="form.datenschutz"
						class="form-check-input"
						type="checkbox"
						id="invalidCheck"
						required
						:disabled="isSend"
					/>
					<label class="form-check-label" for="invalidCheck">
						Ich akzeptiere die Datenschutzbestimmungen.
					</label>
				</div>
				<div class="form-msg form-error-msg w-100">
					Eine Zustimmung ist für die Anfrage erforderlich.
				</div>
				<div class="d-flex w-100 cm-contact-infotext border-top mt-3 pt-3">
					<div class="infotext-body mb-3">
						<p class="text-muted lh-sm">
							Eine Zustimmung unserer Datenschutzbestimmen ist erforderlich,
							damit wir Sie kontaktieren dürfen. Informationen zur Verarbeitung
							Ihrer Daten
							<a
								href="/datenschutz"
								target="_blank"
								class="link-dark"
								title="Darmen Datenschutzbestimmungen"
								>Unsere Datenschutzbestimmungen</a
							>. Ihre Nachricht wird vor der Weiterleitung geprüft. Eine Kopie
							Ihrer Anfrage wird an die angegebe E-Mail-Adresse
							<template v-if="form.email !== ''">({{ form.email }})</template>
							geschickt. Geschützt durch reCAPTCHA. (<a
								href="https://www.google.com/intl/de/policies/privacy/"
								title="Google Datenschutzbestimmungen"
								target="_blank"
								class=""
								>Datenschutz</a
							>
							|
							<a
								href="https://www.google.com/intl/de/policies/terms/"
								title="Google Nutzungsbedingungen"
								target="_blank"
								class=""
								>Nutzungsbedingungen</a
							>).
						</p>
					</div>

					<div class="infotext-img pt-2 ms-2">
						<img
							src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
							alt="Recaptcha Logo"
						/>
					</div>
				</div>
				<button
					class="btn btn-dark btn-cm-form-submit form"
					:class="{ 'btn-cm-form-is-send': isSend }"
					type="submit"
					:disabled="isSending || isSend"
				>
					<template v-if="isSend"
						><i class="mdi mdi-email-check"></i> Gesendet
					</template>
					<template v-else-if="isSending"
						>Wird gesendet... <i class="mdi mdi-send-clock"></i
					></template>
					<template v-else>Jetzt senden <i class="mdi mdi-send"></i></template>
				</button>
			</div>
		</div>
	</form>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'
import store from '@/store'
import DarmasApiService from '@/services/DarmasApiService'

export default {
	name: 'DetailsRequestForm',
	components: {},
	props: {
		car: Object,
		carTitle: String,
		price: Object,
		store: Object
	},
	setup() {
		return { v$: useVuelidate() }
	},
	data() {
		return {
			isSend: false,
			isSending: false,
			carData: {},
			form: {
				car_id: '',
				angebots_nr: '',
				cm_id: '',
				subject: [],
				standort: '',
				contact_type: '',
				payment: 'fixed',
				payment_details: '',
				ankauf: '',
				firma: '',
				vorname: '',
				nachname: '',
				email: '',
				phone: '',
				datenschutz: '',
				message: `Sehr geehrte Damen und Herren,

ich interessiere mich für Ihr Angebot. Bitte kontaktieren Sie mich.

Mit freundlichen Grüßen`
			}
		}
	},
	computed: {
		hostName() {
			return window.location.protocol + '//' + window.location.hostname
		},
		sendRequestUrl() {
			return (
				this.hostName +
				'/index.php?option=com_ajax&module=darmas&format=json&method=sendRequest'
			)
		},
		formExtraText() {
			if (store.state.price.view === 'finance') {
				return (
					'Finanzierungsinformationen werden übertragen: ' +
					store.state.price.financing.deposit +
					', ' +
					store.state.price.financing.period
				)
			} else {
				return 'Information zur Kaufoption werden übertragen.'
			}
		}
	},
	validations() {
		return {
			formToken: '',
			form: {
				nachname: {
					required
				},
				vorname: {
					required
				},
				email: {
					required,
					email
				},
				message: {
					required
				},
				datenschutz: {
					required
				},
				contact_type: {
					required
				},
				payment: {
					required
				},
				phone: {
					required
				}
			}
		}
	},
	methods: {
		setFormMessage(priceView) {
			this.form.payment = priceView
			store.state.price.view = priceView
			this.form.message = this.getFormMessage(priceView)
		},
		getPaymentText() {
			let price = store.state.price

			if (price.view === 'finance') {
				return {
					price: this.car.consumerPriceGross,
					period: price.financing.period,
					deposit: price.financing.deposit,
					rate: price.financing.rate
				}
			} else if (price.view === 'leasing') {
				return {
					price: this.car.consumerPriceGross,
					period: price.leasing.period,
					deposit: price.leasing.deposit,
					mileage: price.leasing.mileage,
					rate: price.leasing.rate
				}
			} else {
				return {
					price: this.car.consumerPriceGross
				}
			}
		},
		getFormMessage(priceView) {
			let price = store.state.price
			let message = ''

			if (priceView === 'finance') {
				message += `ein Finanzierungsangebot.`
			} else if (priceView === 'leasing') {
				message += `ein Leasingangebot.`
			} else {
				message += 'Ihr Angebot.'
			}

			return `Sehr geehrte Damen und Herren,

ich interessiere mich für ${message}

Mit freundlichen Grüßen`
		},
		async recaptcha() {
			// (optional) Wait until recaptcha has been loaded.
			await this.$recaptchaLoaded()

			// Execute reCAPTCHA with action "login".
			const token = await this.$recaptcha('submit')

			return token

			// Do stuff with the received token.
		},
		async sendMessage() {
			this.v$.$touch()
			if (this.v$.$error) {
				this.$toast('Bitte alle Pflichtfelder ausfüllen!', {
					type: 'error'
				})
			} else {
				this.form.payment = store.state.price.view
				this.form.payment_details = JSON.stringify(this.getPaymentText())
				this.isSending = true
				await this.$recaptchaLoaded()
				const token = await this.$recaptcha('submit')
				DarmasApiService.verifyRecaptchaToken(token)
					.then(response => {
						//console.log(token)
						//console.log(response)
						if (response.data.success) {
							const postData = {
								jform: this.form,
								car: this.carData
							}

							this.isSending = true
							DarmasApiService.sendRequestMessage(
								postData,
								store.state.user.token
							)
								.then(response => {
									this.$toast('Nachricht erfolgreich versendet!', {
										type: 'success'
									})
									this.isSend = true
								})
								.catch(error => {
									this.$toast(
										'Fehler beim senden, bitte versuchen Sie es später noch einmal',
										{
											type: 'error'
										}
									)
									this.isSending = false
									console.log(error)
								})
						} else {
							this.isSending = false
							this.$toast(
								'Ihre Sitzung ist ungültig, bitte Seite erneut laden',
								{
									type: 'error'
								}
							)
						}
					})
					.catch(error => {
						this.$toast(error, {
							type: 'error'
						})
						console.log(error)
					})
			}
		}
	},
	created() {
		this.form.payment = store.state.price.view
		this.form.payment_details = this.getPaymentText()
		this.form.message = this.getFormMessage(store.state.price.view)
		this.form.car_id = this.car.dispo24VehicleId
		this.form.cm_id = this.car._id
		this.form.angebots_nr = this.car.ad.internalNumber
		this.form.standort = this.car.store.alias

		this.carData = this.car.ad
	}
}
</script>

<style scoped></style>
